<template>
  <div>
    <div
      class="flex flex-col p-5 bg-white bg-opacity-50 text-base text-black uppercase"
      style="backdrop-filter: blur(25px)"
    >
      <component :is="`Svg${data.aircraft_type.icao_code}`" width="150" height="40" class="max-w-full" />
      <span class="mt-6 font-medium">With {{ data.aircraft_type.name }}</span>
      <span class="mt-2 font-header font-bold text-4xl">{{ formattedFlightTime }}</span>
    </div>
    <div class="flex flex-col gap-1.5 pt-4 pb-1.5 bg-cream-100 text-grey">
      <div class="flex justify-between gap-1.5 py-1.5 px-5">
        <span>Departure fee</span>
        <span class="font-medium text-taupe-500">{{ formatCurrency(data.departure_airport_fees) }}</span>
      </div>
      <div class="flex justify-between gap-1.5 py-1.5 px-5">
        <span>Arrival fee</span>
        <span class="font-medium text-taupe-500">{{ formatCurrency(data.arrival_airport_fees) }}</span>
      </div>
      <div class="flex justify-between gap-1.5 bg-cream-200 py-1.5 px-5">
        <span>Flight price</span>
        <span class="font-medium text-taupe-500">{{ formatCurrency(data.flight_price) }}</span>
      </div>
      <div class="flex justify-between gap-1.5 py-1.5 px-5 font-bold text-black">
        <span>Total price</span>
        <span>{{ formatCurrency(data.total_price) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import SvgPC12 from '@/components/svg/PC12'
import SvgPC24 from '@/components/svg/PC24'
import SvgSF50 from '@/components/svg/SF50'
import formatCurrency from '@/utils/formatCurrency'

export default {
  components: { SvgPC12, SvgPC24, SvgSF50 },
  props: {
    data: { type: Object, required: true },
  },
  computed: {
    formattedFlightTime () {
      const hours = this.data.total_flight_time / 60
      const rhours = Math.floor(hours)
      const minutes = Math.round((hours - rhours) * 60)
      let rminutes
      if (minutes === 0) rminutes = '00'
      else if (minutes < 10) rminutes = '0' + minutes
      else rminutes = minutes
      return `${rhours}H${rminutes}`
    }
  },
  methods: {
    formatCurrency,
  },
}
</script>
